// 获取项目配置并初始化mixin
import { BASEKEY } from '@/config';

export default {
  data() {
    return {
      userName: '',
      isLogin: false,
      langObj: {},
      setting: {},
      langTypes: [
        {
          value: 0,
          key: 'zh',
          name: '中文',
        },
        {
          value: 1,
          key: 'en',
          name: 'English',
        },
      ],
      locale: 'zh', // 选中的语言
      langType: -1,
      brandInfo: {},
      siteLogoUrl: '',
      siteLogoUrlEn: '',
    };
  },
  methods: {
    getWebSetting() {
      // 获取配置
      return this.$service.project.getWebSetting({ content: { type: 0 } })
        .then((result) => {
          if (!Object.prototype.hasOwnProperty.call(result, 'data')) {
            // this.$Message.error({ content: this.$t('tip.webDisable') });
            throw new Error('data is undefined');
          }
          if (Object.keys(this.$service.project.setting).length) {
            throw new Error('setting is not empty');
          }
          const setting = result.data;
          window.document.title = setting.siteName || '广州餐道';
          setting.allStoreUrlEn = '';
          setting.langType = [0, 1, 2];
          return this.$service.project.getThridConfig(BASEKEY)
            .then((data) => {
              // 获取第三方配置成功
              if (data) { // this.compArr = data.pages.Index.json;
                this.setting = data;
                this.langObj = data.langObj;
                setting.langType = [];
                // wbms 配置语言
                if (this.langObj) {
                  this.langObj.langsArray.forEach((x) => {
                    if (x === 'zh') {
                      setting.langType.push(0);
                    } else if (x === 'hk') {
                      setting.langType.push(1);
                    } else if (x === 'en') {
                      setting.langType.push(2);
                    }
                  });
                }
              }
              // Vue.prototype.$setting = setting;
              return setting;
            });
        })
        .then((setting) => {
          const langTypes = [];
          setting.langType.forEach((lang) => {
            switch (lang) {
              case 0:
                if (localStorage.getItem('lang') === 'zh') {
                  this.langType = 0;
                  this.locale = 'zh';
                }
                langTypes.push({
                  value: 0,
                  key: 'zh',
                  name: '中文',
                });
                break;
              case 2:
                if (localStorage.getItem('lang') === 'en') {
                  this.langType = 2;
                  this.locale = 'en';
                }
                langTypes.push({
                  value: 2,
                  key: 'en',
                  name: 'ENGLISH',
                });
                break;
              default:
                break;
            }
          });
          setting.langType.sort((a, b) => a - b);
          this.siteLogoUrl = setting.siteLogoUrl;
          this.siteLogoUrlEn = setting.siteLogoUrlEn;
          this.brandInfo = { ...setting };
          this.langTypes = [...langTypes];
          if (this.locale === '') {
            this.langType = langTypes[0].value;
            this.locale = langTypes[0].key;
          }
          return this.$service.caches.set({ langType: this.langType });
        })
        .then(() => {
          this.$i18n.locale = this.locale; // 改变语言环境
        })
        .catch(() => { // 获取第三方配置失败
          // console.log(err);
          // this.$Message.error('网站停用或网络异常，请稍后再试');
        });
    },
  },
};
